import { render, staticRenderFns } from "./HighlightCovers.vue?vue&type=template&id=7986d6dd"
import script from "./HighlightCovers.vue?vue&type=script&lang=js"
export * from "./HighlightCovers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports